import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedProspectBuyingWishApiService } from './prospect-buying-wish-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ProspectBuyingWishApiService extends GeneratedProspectBuyingWishApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
